var map = {
	"./BgManager": 47,
	"./BgManager.js": 47,
	"./CanvasClear": 94,
	"./CanvasClear.js": 94,
	"./CommandAbstract": 35,
	"./CommandAbstract.js": 35,
	"./ComponentDelete": 95,
	"./ComponentDelete.js": 95,
	"./ComponentEnter": 96,
	"./ComponentEnter.js": 96,
	"./ComponentExit": 97,
	"./ComponentExit.js": 97,
	"./ComponentNext": 98,
	"./ComponentNext.js": 98,
	"./ComponentPrev": 99,
	"./ComponentPrev.js": 99,
	"./ComponentStyleClear": 100,
	"./ComponentStyleClear.js": 100,
	"./CopyComponent": 101,
	"./CopyComponent.js": 101,
	"./CreateComponent": 15,
	"./CreateComponent.js": 15,
	"./DeleteComponent": 37,
	"./DeleteComponent.js": 37,
	"./Drag": 55,
	"./Drag.js": 55,
	"./ExportTemplate": 36,
	"./ExportTemplate.js": 36,
	"./Fullscreen": 52,
	"./Fullscreen.js": 52,
	"./ImageComponent": 38,
	"./ImageComponent.js": 38,
	"./InsertCustom": 26,
	"./InsertCustom.js": 26,
	"./LocationManager": 46,
	"./LocationManager.js": 46,
	"./MoveComponent": 39,
	"./MoveComponent.js": 39,
	"./OpenAssets": 49,
	"./OpenAssets.js": 49,
	"./OpenBlocks": 48,
	"./OpenBlocks.js": 48,
	"./OpenLayers": 42,
	"./OpenLayers.js": 42,
	"./OpenStyleManager": 43,
	"./OpenStyleManager.js": 43,
	"./OpenTraitManager": 44,
	"./OpenTraitManager.js": 44,
	"./PasteComponent": 102,
	"./PasteComponent.js": 102,
	"./Preview": 53,
	"./Preview.js": 53,
	"./Resize": 54,
	"./Resize.js": 54,
	"./SelectComponent": 14,
	"./SelectComponent.js": 14,
	"./SelectParent": 51,
	"./SelectParent.js": 51,
	"./SelectPosition": 25,
	"./SelectPosition.js": 25,
	"./ShowOffset": 50,
	"./ShowOffset.js": 50,
	"./SwitchVisibility": 41,
	"./SwitchVisibility.js": 41,
	"./TemplateList": 45,
	"./TemplateList.js": 45,
	"./TextComponent": 40,
	"./TextComponent.js": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;